import { AlertCircle } from "lucide-react";

/**
 * Sponsored Content Badge
 * 
 * Use this to mark sponsored/paid articles
 * Required by FTC and Brazilian advertising laws
 */
const SponsoredBadge = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 ${className}`}>
      <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0" />
      <div>
        <p className="text-sm font-medium text-amber-900">
          Conteúdo Patrocinado
        </p>
        <p className="text-xs text-amber-700">
          Este artigo contém conteúdo promocional pago
        </p>
      </div>
    </div>
  );
};

export default SponsoredBadge;